import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { routesPath } from '@router/routes';

import { useAuthSlice } from '@restore/auth/auth.slice';
import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { useClinicalTrialAffiliatesSlice } from '@restore/clinicalTrialAffiliates/clinicalTrialAffiliates.slice';
import { ClinicalTrialAffiliatesType } from '@dynamika-shared/types/clinicalTrialAffiliates';
import { ClinicalTrialList } from '@components/LoginSelections/ClinicalTrialList/ClinicalTrialList';

export const ReaderMenu = () => {
  const navigate = useNavigate();
  const userData = useAuthSlice(s => s.data);
  const { id: clinicalTrialId } = useParams<{
    id: string;
  }>();

  const [dataCT, fetchClinicalTrials] = useClinicalTrialAffiliatesSlice(
    (state, actions) => [state.data, actions.fetchClinicalTrialAffiliates]
  );

  const [fetchContext, clearData, contextData] = useClinicalTrialContextSlice(
    (state, actions) => [
      actions.fetchClinicalTrialContext,
      actions.clearData,
      state.data,
    ]
  );

  useEffect(() => {
    if (!dataCT?.length) {
      fetchClinicalTrials(null);
    }
  }, [dataCT]);

  useEffect(() => {
    if (clinicalTrialId && clinicalTrialId !== contextData?.configuration?.id) {
      const setNewContext = async (ctId: string) => {
        clearData();
        fetchContext(ctId);
      };
      setNewContext(clinicalTrialId);
    }
  }, [clinicalTrialId]);


  const handleSelectCT = (clinicalTrial: ClinicalTrialAffiliatesType) => {
    navigate(`${routesPath.reader}/${clinicalTrial.id}`);
  };

  if (!userData?.selectedRole) {
    return null;
  }
  return (
    <ClinicalTrialList
      clinicalTrials={dataCT}
      handleSelectCT={handleSelectCT}
      context={'menu'}
    />
  );
};
